import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes } from '../global/constants';
import { mediaQueryString } from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Variables ----------

		let mobileAnimations = [];
		let menuAnimations = [];
		let desktopAnimations = [];
		let globalAnimations = [];

		// ---------- Animated Section ----------

		$('.animated-section:not(.transition-clone)').each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						once: true,
						start: 'top 80%',
						toggleClass: Classes.active,
					}
				});
			});
		});

		// ---------- Parallax Section ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

			desktopAnimations.push(() => {

				const image = this.querySelector(':scope .section-image');
				const speed = 25;

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
						},
					});

					timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
				}
			});
		});

		$('.double-text-image-section, .page-link-section').each(function() {

			menuAnimations.push(() => {

				const image = this.querySelector(':scope .image-column');

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
						},
					});

					timeline.fromTo(image, {
						y: () => (this.classList.contains('page-link-section')) ? -120 : 0
					}, {
						y: () => (this.classList.contains('page-link-section')) ? this.clientHeight - image.clientHeight - 120 : this.clientHeight - image.clientHeight
					});
				}
			});
		});

		$('.page-link-section').each(function() {

			menuAnimations.push(() => {

				const icons = document.querySelectorAll('[id^="tc-svg-home-icon"] .text');

				if(icons) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
						},
					});

					timeline.fromTo(icons, {
						rotate: 0,
						transformOrigin: '50% 50%',
					}, {
						rotate: 360,
						transformOrigin: '50% 50%',
					});
				}
			});
		});

		$('.single-wine-section').each(function() {

			desktopAnimations.push(() => {

				const slideshow = this.querySelector('.wine-image-column .column-content');

				if(slideshow) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom bottom',
							toggleClass: {
								targets: slideshow,
								className: Classes.active
							}
						},
					});
				}
			});
		});

		// ---------- Handle Media Queries ----------

		ScrollTrigger.matchMedia({

			// Desktop Animations
			[mediaQueryString(Breakpoints.Mobile)]: () => desktopAnimations.map(animation => animation()),

			// Menu Animations
			[mediaQueryString(Breakpoints.Menu)]: () => menuAnimations.map(animation => animation()),

			// Mobile Animations
			[mediaQueryString(Breakpoints.Mobile, false)]: () => mobileAnimations.map(animation => animation()),

			// Global Animations
			'all': () => globalAnimations.map(animation => animation()),

		});

	});

}(jQuery));
